import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/draftSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const DraftAttemptFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.draft.filterOptions.draftAttemptOptions);
  const selected = useSelector((state) => state.draft.selectedFilters.draftAttempts);

  if (!options || !options.length) return null;

  return (
    <div className="select-box-no-width">
      <p>Draft Attempt</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selected}
        includeFilter={false}
        multiSelect
        enableOnly
        numberDisplayed={0}
        onSelectChange={(data) => dispatch(actionCreators.updateDraftAttempt(data))}
      />
    </div>
  );
};
